import React from 'react';
import * as Icons from 'react-icons/tb';

function Checkbox({ label, isChecked, onCheckboxChange }) {
  return (
    <div className="checkbox-container">
      <label className="checkbox-label">
        <input
          type="checkbox"
          checked={isChecked}
          onChange={onCheckboxChange}
          className="hidden-checkbox"
        />
        <div className={`custom-checkbox ${isChecked ? 'checked' : ''}`}>
          <Icons.TbCheck />
        </div>
        {label}
      </label>
    </div>
  );
}

export default Checkbox;
